import { useDisclosure } from '@mantine/hooks'
import { subscriptionHooks } from '$src/lib/trpcHooks'
import { MaintenanceLogModal } from './MaintenanceLogModal'
import { StatusTile } from './StatusTile'
import { groupServices } from './utils'

interface MaintenanceLogSectionProps {
  propertyId: number
  companyId: string
}

/**
 * Compact maintenance-status tile (sits beside the CSAT tile). Clicking it
 * opens the detailed huoltokirja modal with the per-task liikennevalo list.
 */
export function MaintenanceLogSection({
  propertyId,
  companyId,
}: MaintenanceLogSectionProps) {
  const { data, isLoading } =
    subscriptionHooks.useServiceStatusByProperty(propertyId)
  const [opened, { open, close }] = useDisclosure(false)

  if (isLoading || !data?.services?.length) {
    return null
  }

  const { counts } = groupServices(data.services)

  return (
    <>
      <StatusTile counts={counts} onOpen={open} />
      <MaintenanceLogModal
        opened={opened}
        onClose={close}
        data={data}
        companyId={companyId}
      />
    </>
  )
}
